<template>
  <div class="autocomplete">
    <div class="autocomplete__fillin">
      <label class="autocomplete__label" v-if="labelText">{{
        labelText
      }}</label>
      <div class="autocomplete__content">
        <b-form-input
          :ref="id"
          :id="id"
          :type="type"
          :placeholder="placeholder"
          :value="value"
          debounce="200"
          :disabled="disabled"
          :state="validateState(name)"
          :name="name"
          :data-vv-name="name"
          v-validate="validation"
          @focus="focus"
          @blur="blur"
          @update="$emit('input', $event)"
          class="autocomplete__content-input"
        ></b-form-input>
        <ul class="autocomplete__content-dropdown" v-if="dropdownShow">
          <!-- 這裏一定要用 mousedown，因為 click event 會在 blur 之後 trigger
        ，而 mousedown 會在 blur 之前 trigger-->
          <li
            v-for="(item, index) in items"
            :key="index"
            @mousedown="selectDropdownItem(item)"
            class="autocomplete__content-dropdown-item"
          >
            {{ item.value }}
          </li>
        </ul>
      </div>
    </div>
    <p v-if="veeErrors.has(name)" class="form-error-messgae">
      {{ veeErrors.first(name) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AutoComplete',
  props: {
    labelText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    validation: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dropdownShow: false,
      show: false,
      buttonShow: true
    };
  },
  methods: {
    focus() {
      this.focusedInput = this.id;
    },
    blur() {
      this.dropdownShow = false;
    },
    selectDropdownItem(item) {
      this.$emit('selectDropdownItem', item);
      this.dropdownShow = false;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    }
  },
  watch: {
    items: function (value) {
      if (this.dropdownShow) return;
      if (value.length && document.activeElement.id === this.id)
        this.dropdownShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.autocomplete {
  &__fillin {
    display: flex;
    align-items: center;
    font-size: 13px;
  }
  label {
    flex: 0 0 80px;
    margin-bottom: 0;
  }

  input {
    width: 100%;
  }

  &__content {
    position: relative;
    width: 100%;
    &-dropdown {
      position: absolute;
      top: 100%;
      z-index: 2;
      width: 100%;
      height: fit-content;
      max-height: 150px;
      overflow: scroll;
      padding: 8px 0;
      margin-bottom: 0;
      margin-top: 5px;
      background-color: $white;
      border: 1px solid $border-gentle;
      border-radius: 5px;
      box-shadow: 0 1px 5px #00000022;
      &-item {
        list-style: none;
        padding: 5px 20px;
        cursor: pointer;
        &:hover {
          background-color: #fafafa;
        }
      }
    }
  }
}

.widerlabel {
  label {
    flex: 0 0 100px;
  }
}
</style>
